import { render, staticRenderFns } from "./ThemeCustomization.vue?vue&type=template&id=64196c8f&"
import script from "./ThemeCustomization.vue?vue&type=script&lang=js&"
export * from "./ThemeCustomization.vue?vue&type=script&lang=js&"
import style0 from "./ThemeCustomization.vue?vue&type=style&index=0&id=64196c8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports